import * as React from "react";
import { BaseComponent } from "../../../react-core/Html/BaseComponent";
import { TextAndDotsDropdown } from "./TextAndDotsDropdown";
import * as classNames from "classNames";
import { PartLoading } from "../../../react-core/Html/PartLoading";

export interface ITextAndDotsProps {
    textLinks: TextLink[];
    buttonTitle?: string;
    textAndDotsWrapperCSS?: string;
    showCloseButton?: boolean;
    isLoading?: boolean;
    onMenuClick?: (processType:string) => void;
}

export interface ITextAndDotsState {}

export type TextLinkWithUrl = {
    title: string;
    url: string;
};

export type TextLinkWithClickHandler = {
    title: string;
    clickFunction: VoidFunction;
};

export type TextLink = TextLinkWithUrl | TextLinkWithClickHandler;

function isTextLinkWithurl(maybeLinkWithUrl: TextLink): maybeLinkWithUrl is TextLinkWithUrl {
    return Boolean((maybeLinkWithUrl as TextLinkWithUrl).url);
}

function isTextLinkWithClickHandler(
    maybeLinkWithClickHandler: TextLink
): maybeLinkWithClickHandler is TextLinkWithClickHandler {
    return Boolean((maybeLinkWithClickHandler as TextLinkWithClickHandler).clickFunction);
}

export class TextAndDots extends BaseComponent<ITextAndDotsProps, ITextAndDotsState> {
    constructor(props: ITextAndDotsProps) {
        super(props);
        this.state = {
            setVisibility: false,
        };
    }

    private lightbox;

    public render(): JSX.Element {
        let { textLinks, buttonTitle, isLoading } = this.props;
        const textAndDotsWrapperCSS = classNames("dots-wrap", this.props.textAndDotsWrapperCSS, {
            "is-dismissable": this.props.showCloseButton,
        });
        const toggleVisibility = () => {
            this.setState(!this.state);            
        };

        const renderPartLoading = () => {
            return (
                <PartLoading isLoading={true}>
                    <div className="table-skeleton"></div>
                </PartLoading>
            );
        }

        textLinks = textLinks.filter((ele) => isTextLinkWithurl(ele) || isTextLinkWithClickHandler(ele));

        return (
            <div className={textAndDotsWrapperCSS}>
                <TextAndDotsDropdown cssWrapper="label-sr-only" buttonTitle={buttonTitle} onRef={(ref) => (this.lightbox = ref)}>
                    {this.props.showCloseButton && (
                        <div className="mt-20">
                            <button
                                className="text-and-dots-close-button label-sr-only"
                                onClick={() => toggleVisibility()} 
                            >
                                <span className="icon" aria-hidden={true}></span>
                                <span className="text">Dismiss this dropdown</span>
                            </button>
                        </div>
                    )}
                    {isLoading && renderPartLoading()}
                    {!isLoading && textLinks.map((ele, index) => {
                        return (
                            <a
                                key={`textLinks-${index}`}
                                className="item"
                                onClick={
                                    isTextLinkWithClickHandler(ele)
                                        ? () => {
                                              ele.clickFunction();
                                              if (this.lightbox) {this.lightbox.ToggleDropdown();this.props.onMenuClick(ele.title);}
                                          }
                                        : null
                                }
                                href={isTextLinkWithurl(ele) ? ele.url : null}
                            >
                                {ele.title}
                            </a>
                        );
                    })}
                </TextAndDotsDropdown>
            </div>
        );
    }
}
